import { Component, h, Prop } from '@stencil/core';
import { Article, DetailsComponents } from '../../utils/types';
import { SelectOption, SelectStyle } from '../../../../types/types';
import { t } from '../../../../redux/utils';

@Component({
  tag: 'rtr-article-details-options',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RtrArticleDetailsOptions {
  @Prop() article: Article;
  @Prop() detailsComponent: DetailsComponents;

  get showOptions() {
    return this.article.mileage || this.article.variation;
  }

  get variationOptions(): SelectOption[] {
    return this.article.variation.items.map(item => {
      return {
        label: item.name,
        value: item.id,
        disabled: !item.maxQuantity && !item.quantityInCart,
      };
    });
  }

  get optionsText() {
    return t('details.options');
  }

  render() {
    return (
      <div class="ADDWrapper">
        {this.showOptions && (
          <div class="ADDOptionsContainer">
            <rentware-spacer size="M" />
            <span class="ADDOptionsTitle">{this.optionsText}</span>

            <div class="ADDOptionsSelectsContainer">
              {this.article.mileage && (
                <div class="ADDOptionContainer">
                  <rentware-select-mileage
                    selectStyle={SelectStyle.Default}
                    mileageOptions={this.article.mileage}
                    available={this.article.available}
                    selectedMileageId={this.article.selectedMileageId}
                    onMileageChange={this.article.onMileageChange}
                    isWaiting={this.article.isWaiting}
                  />
                </div>
              )}

              {this.article.variation && (
                <div class="ADDOptionContainer">
                  <rentware-select
                    selectStyle={SelectStyle.Default}
                    label={this.article.variation.name}
                    value={this.article.selectedVariationId}
                    onValueChange={e => this.article.onVariationChange(e.detail.value)}
                    options={this.variationOptions}
                  />
                </div>
              )}

              {this.article.isWaiting && <div class="ADDWaiting" />}
            </div>
            <rentware-spacer size="S" />
            <rentware-divider />
          </div>
        )}
      </div>
    );
  }
}
